import React from 'react'
import { DATA_TEST_ID } from 'shared-constants/build/testIds'
import {
  useCmsArticlePageBySlug,
  prepareGetStaticPropsForArticlePage,
} from '@public/CmsPage/ArticlePage'
import { getPublicLayout } from '@public/components/PublicLayout'
import { Box } from 'components/Layout'
import { LOADER_SIZE } from 'components/Loader'
import { PureSSRIndicator } from 'components/PureSSRIndicator'
import { WidgetsWrapper } from 'components/Widgets'
import { PAGE_MIN_HEIGHT, WrappedLoader } from 'components/WrappedLoader'
import { FAQ_PAGE_SLUG } from 'constants/common'
import { SPACE } from 'Theme'

export const FAQ = () => {
  const { widgets, isLoading } = useCmsArticlePageBySlug({
    slug: FAQ_PAGE_SLUG,
  })

  if (isLoading) {
    return (
      <WrappedLoader
        loaderSize={LOADER_SIZE.XXXL}
        minHeight={PAGE_MIN_HEIGHT}
      />
    )
  }

  return (
    <Box mt={SPACE.PX_80} mb={SPACE.PX_120} data-test-id={DATA_TEST_ID.FAQ}>
      <WidgetsWrapper widgets={widgets} slug={FAQ_PAGE_SLUG} />
      <PureSSRIndicator />
    </Box>
  )
}

export function getStaticProps(context) {
  return prepareGetStaticPropsForArticlePage(context, { slug: FAQ_PAGE_SLUG })
}

FAQ.getLayout = (page) =>
  getPublicLayout(page, { isFullWidth: true, isWithBreadcrumbs: true })
